import { render, staticRenderFns } from "./QAgentManagementMenu.vue?vue&type=template&id=3dee4966&"
import script from "./QAgentManagementMenu.vue?vue&type=script&lang=js&"
export * from "./QAgentManagementMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports